import { privateRequest, publicRequest, referralRequest, type ApiResponse } from "../../axios";
import { type AxiosResponse } from "axios";

let url: string | undefined = window.location.href;
url = url.split("/")[2];

const ENDPOINTS = {
  WEBAPP: `api/WebAppSetting?url=${url}`,
  LOGIN: "api/account/authenticate",
  LOGIN_WITH_OTP: "api/Account/LoginWithOTP",
  LOGOUT: "api/auth/logout",
  GENERATE_LOGIN_OTP: "api/Account/GenerateLoginOTP",
  SIGN_UP: "api/WebUserRegister",
  GET_COUNTRIES: "api/GetCountryList",
  RESET_PASSWORD: "api/Account/ResetPassword",
  REFERRAL_LINK: "referral/ReferralRedirect/SignUp",
  GENERATE_USER_OTP: "api/Account/GenerateUserOTP",
  LOGIN_WITH_REDIRECT:"api/Account/loginWithToken",
};

const webAppSetting = async (): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await publicRequest.get(
      ENDPOINTS.WEBAPP
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const login = async (data: any, captchaToken?: string): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await publicRequest.post(
      ENDPOINTS.LOGIN,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          ...(captchaToken && { "captcha-token": captchaToken }),
        },
      }
    );

    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const loginWithOtp = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await publicRequest.post(
      ENDPOINTS.LOGIN_WITH_OTP,
      data
    );

    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const logout = async (): Promise<{ message: string }> => {
  const response: AxiosResponse<{ message: string }> =
    await privateRequest.post(ENDPOINTS.LOGOUT);
  return response.data;
};

const generateLoginOTP = async (data: any, captchaToken?: string): Promise<{ message: string }> => {
  try {
    const response: AxiosResponse<{ message: string }> =
      await publicRequest.post(
        ENDPOINTS.GENERATE_LOGIN_OTP,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            ...(captchaToken && { "captcha-token": captchaToken }),
          },
        }
      );

    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const generateUserOTP = async (data: any, captchaToken?: string): Promise<{ message: string }> => {
  try {
    const response: AxiosResponse<{ message: string }> =
      await publicRequest.post(
        ENDPOINTS.GENERATE_USER_OTP,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            ...(captchaToken && { "captcha-token": captchaToken }),
          },
        }
      );

    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const signUp = async (data: any, captchaToken?: string): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await publicRequest.post(
      ENDPOINTS.SIGN_UP,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          ...(captchaToken && { "captcha-token": captchaToken }),
        },
      }
    );
    if (response.data.Status !== 200) {
      return Promise.reject(response.data);
    }

    return response.data;
  } catch (error: any) {
    return Promise.reject(
      error.response?.data || { Message: error.message, Status: 500 }
    );
  }
};

const getCountries = async (): Promise<ApiResponse<any>> => {
  try {
    const response = await publicRequest.get<ApiResponse<any>>(
      ENDPOINTS.GET_COUNTRIES
    );

    if (response.data.Status !== 200) {
      throw new Error("Failed to load countries");
    }

    return response.data.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const resetPassword = async (data: any): Promise<{ success?: boolean, message?: string }> => {
  try {
    const response: AxiosResponse<{ success?: boolean, message?: string }> =
      await publicRequest.post(ENDPOINTS.RESET_PASSWORD, data);
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const referralLink = async (): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await referralRequest.get(
      ENDPOINTS.REFERRAL_LINK
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};


const loginWithRedirect = async (token: any): Promise<any> => {
  const res : AxiosResponse<any> = await privateRequest.get(`${ENDPOINTS.LOGIN_WITH_REDIRECT}?token=${token}`);
  return res.data;
}

const AuthService = {
  login,
  logout,
  generateLoginOTP,
  resetPassword,
  webAppSetting,
  signUp,
  getCountries,
  referralLink,
  loginWithOtp,
  generateUserOTP,
  loginWithRedirect
};

export default AuthService;
